export default "__VITE_ASSET__d88ee5d8__"